import { render } from "./ValidationPage.vue?vue&type=template&id=c8cf1dc6&scoped=true"
import script from "./ValidationPage.vue?vue&type=script&lang=js"
export * from "./ValidationPage.vue?vue&type=script&lang=js"

import "./ValidationPage.vue?vue&type=style&index=0&id=c8cf1dc6&scoped=true&lang=css"

import exportComponent from "/Users/durul/Downloads/projects/backend/validationVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8cf1dc6"]])

export default __exports__